var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageorgActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00195 26V3.5C6.00195 3.1625 6.00195 2.8125 6.08945 2.475C6.16596 2.13828 6.33537 1.82977 6.57842 1.58451C6.82148 1.33924 7.12844 1.16705 7.46445 1.0875C7.82695 1 9.41445 1 9.75195 1H18.502C18.8395 1 19.1895 1 19.527 1.0875C19.8637 1.16401 20.1722 1.33341 20.4174 1.57647C20.6627 1.81952 20.8349 2.12649 20.9145 2.4625C21.002 2.8125 21.002 3.1625 21.002 3.5V26H6.00195Z",
    fill: "#3361CF",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00278 16V23.5C1.00278 24.875 2.12778 26 3.50278 26H6.00278V13.5H3.50278C3.16528 13.5 2.81528 13.5 2.47778 13.5875C2.14028 13.675 1.82778 13.8375 1.57778 14.0875C1.34028 14.325 1.17778 14.6375 1.09028 14.975C1.01972 15.3119 0.990335 15.6561 1.00278 16Z",
    fill: "#3361CF",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.527 9.83735C24.1901 9.76679 23.8459 9.73741 23.502 9.74985H21.002V25.9998H23.502C24.165 25.9998 24.8009 25.7365 25.2697 25.2676C25.7386 24.7988 26.002 24.1629 26.002 23.4998V12.2498C26.002 11.8998 26.002 11.5623 25.9145 11.2248C25.827 10.8873 25.6645 10.5748 25.4145 10.3248C25.177 10.0873 24.8645 9.92485 24.527 9.83735Z",
    fill: "#3361CF",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.002 6H16.002",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.002 11H16.002",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.002 16H16.002",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.002 21H16.002",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageorgActive);
export default __webpack_public_path__ + "static/media/manage org_active.4f10bfc58d3fa6c2bd938017cc2d98d0.svg";
export { ForwardRef as ReactComponent };